(function () {
  // Savings percentages are whole numbers rounded down, so a saving is never overstated (4.9% shows 4%).
  function pctOff(was, now) { return was > 0 && now < was ? Math.floor(((was - now) * 100) / was + 1e-9) : 0; }
  function units(product, variant) {
    const title = product.title.toLowerCase();
    // Counts verified against each bundle's published component list.
    const bulkBundles = {
      'ultimate-5lb-bag-variety-pack': [8, 0],
      '5lb-bag-fresh-ground-variety-pack': [4, 0],
      '5lb-bag-whole-bean-variety-pack': [4, 0],
      'perfectly-prepared-host-5lb-fresh-ground-variety-pack': [2, 0],
      'perfectly-prepared-host-5lb-whole-bean-variety-pack': [2, 0],
      'all-day-drinker-whole-bean-variety-pack': [2, 1]
    };
    const bulk = bulkBundles[product.handle];
    if (bulk) return { count: (bulk[0] * 2267.96 + bulk[1] * 340.194) / 15, packs: bulk[0] + bulk[1], noun: 'cup', estimated: true };
    const count = Number((variant.title.match(/^\s*(\d+)/) || [])[1] || 1);
    if (/steep bags/.test(title)) return { count: /10.pack/i.test(variant.title) ? 10 : 1, noun: 'serving', estimated: false };
    if (/cups/.test(title) && !/reusable/.test(title)) {
      const cups = variant.title.match(/(\d+)\s*cups/i);
      if (cups) return { count: Number(cups[1]), noun: 'cup', estimated: false };
      const boxes = /ultimate/.test(product.handle) ? 4 : /variety-pack/.test(product.handle) ? 2 : null;
      return boxes ? { count: boxes * 12, noun: 'cup', estimated: false } : null;
    }
    if (/12oz/.test(title)) {
      const bags = /4-bag/.test(title) ? 4 : /variety pack/.test(title) ? 2 : count;
      return { count: bags * 340.194 / 15, packs: bags, noun: 'cup', estimated: true };
    }
    if (/5lbs/.test(title)) {
      const bags = /4-bag/.test(title) ? 4 : /variety pack/.test(title) ? 2 : count;
      return { count: bags * 2267.96 / 15, packs: bags, noun: 'cup', estimated: true };
    }
    return null;
  }
  function quote(product, variant, planId, quantity) {
    const allocation = planId ? variant.allocations.find(a => String(a.id) === String(planId)) : null;
    if (planId && !allocation) return null;
    const price = allocation ? allocation.price : variant.price;
    const serving = units(product, variant);
    return { price, total: price * quantity, serving, allocation, savings: allocation ? pctOff(variant.price, price) : 0 };
  }
  // "Delivery every 4 Weeks" -> "4 weeks"
  function frequencyLabel(allocation) {
    const match = String(allocation?.name || '').match(/\b(\d+)\s*weeks?\b/i);
    return match ? match[1] + ' weeks' : String(allocation?.name || '').replace(/^\s*delivery every\s*/i, '').trim().toLowerCase();
  }
  // Auto-renewal terms, shown with the main button and in the sticky bar whenever Subscribe & Save is chosen.
  function renewalText(allocation, total, money) {
    if (!allocation) return '';
    const frequency = frequencyLabel(allocation);
    return 'Renews ' + (frequency ? 'every ' + frequency + ' ' : '') + 'at ' + money(total) + ', plus any shipping and tax, until you cancel. Skip, change or cancel any time.';
  }
  // The "How the subscription works" accordion in snippets/alac-pdp-guides.liquid.
  const SUB_HOW_ID = 'alac-sub-how';
  // Writes the renewal terms into a terms line (main button or sticky bar), keeping its "How it works" link to the
  // subscription accordion. Lines built by script get the same text span + link structure as the Liquid one.
  function setTerms(host, text, doc) {
    if (!host) return;
    let span = host.querySelector('[data-alac-terms-text]');
    if (!span) {
      span = doc.createElement('span');
      span.setAttribute('data-alac-terms-text', '');
      host.textContent = '';
      host.append(span);
      if (doc.getElementById(SUB_HOW_ID)) {
        const link = doc.createElement('a');
        link.href = '#' + SUB_HOW_ID;
        link.className = 'alac-terms-link';
        link.textContent = 'How it works';
        host.append(' ', link);
      }
    }
    if (span.textContent !== text) span.textContent = text;
    host.hidden = !text;
  }
  // A link to the accordion opens it first, so the fragment jump lands on its content.
  function openSubHow(doc, target) {
    const link = target && target.closest ? target.closest('a[href="#' + SUB_HOW_ID + '"]') : null;
    if (!link) return false;
    const details = doc.getElementById(SUB_HOW_ID);
    if (!details) return false;
    details.open = true;
    return true;
  }
  // Uses the same 15g dose as the per-cup line; cadence advice appears with the interval picker.
  function supplyText(u, quantity) {
    if (!u || !(u.count > 0) || u.noun !== 'cup') return '';
    const cups = u.count * Math.max(1, Number(quantity) || 1);
    const rounded = Math.floor(cups);
    if (rounded < 2) return '';
    return (u.estimated ? 'About ' : '') + rounded + ' cups per order.';
  }
  // Cadence helper from pack size and dose: the longest offered interval each pack covers at 1 and 2 cups a day.
  function cadenceHelp(u, quantity, cadences) {
    if (!u || !(u.count > 0) || u.noun !== 'cup') return '';
    const list = [...new Set((cadences || []).map(Number).filter(n => n > 0))].sort((a, b) => a - b);
    if (!list.length) return '';
    const cups = u.count * Math.max(1, Number(quantity) || 1);
    const fit = perDay => list.filter(w => w * 7 * perDay <= cups + 1e-9).pop() || null;
    const one = fit(1), two = fit(2);
    if (!one) return 'At 1 cup a day this order lasts about ' + Math.floor(cups) + ' days, so even ' + list[0] + '-week deliveries may run short. A larger pack lasts longer.';
    return 'At 1 cup a day, every ' + one + ' weeks keeps you supplied' + (two ? '; at 2 cups a day, every ' + two + ' weeks.' : '; at 2 cups a day, choose a larger pack.');
  }
  // Custom quantity of the 1-pack that costs more than the matching pack tile: "3 bags for $62.99 saves $2.98".
  function packNudge(tiles, quantity, unitPrice, noun, money) {
    const q = Math.floor(Number(quantity) || 0);
    if (q < 2 || !(unitPrice > 0)) return '';
    const pack = (tiles || []).find(t => t.count === q && t.available !== false && t.price < unitPrice * q);
    return pack ? q + ' ' + noun + ' for ' + money(pack.price) + ' saves ' + money(unitPrice * q - pack.price) : '';
  }
  function thresholdLabel(threshold, money) { return money(threshold).replace(/\.00(?=\D*$)/, ''); }
  function qualifiesShipping(total, threshold, currency) { return currency === 'USD' && threshold > 0 && Number.isFinite(total) && total >= threshold; }
  function shippingHeadline(total, threshold, currency, money) {
    if (currency !== 'USD' || !(threshold > 0) || !Number.isFinite(total) || total < 0) return 'Shipping options at checkout.';
    const minimum = thresholdLabel(threshold, money);
    return qualifiesShipping(total, threshold, currency)
      ? 'Free Regular shipping*: this selection reaches the ' + minimum + ' minimum.'
      : 'This selection is ' + money(threshold - total) + ' short of free Regular shipping at ' + minimum + '.';
  }
  function shippingCondition(threshold, currency, money) {
    return currency === 'USD' && threshold > 0
      ? '*Contiguous US orders qualify when the order total after discounts stays at or above ' + thresholdLabel(threshold, money) + '.'
      : '';
  }
  // The selection is not the whole cart, and later discounts can change eligibility.
  function shippingGuidance(total, threshold, currency, money) {
    const head = shippingHeadline(total, threshold, currency, money);
    if (head === 'Shipping options at checkout.') return head;
    const condition = shippingCondition(threshold, currency, money);
    return head + (condition ? ' ' + condition : '');
  }
  function cadenceGuidance(total, threshold, currency) {
    return currency === 'USD' && threshold > 0 && total < threshold
      ? 'A larger pack may help you reach the minimum; choose a delivery interval that matches your routine.'
      : 'Space deliveries to match how quickly you use this pack.';
  }
  function orderSummary(subscribed, total, frequency, threshold, currency, money) {
    return shippingGuidance(total, threshold, currency, money);
  }
  // Keep the serving estimate tied to the selected purchase mode; the cards compare modes above.
  function unitText(u, price, money) {
    if (!u) return '';
    return (u.estimated ? 'Approx. ' : '') + money(price / u.count) + ' per ' + u.noun;
  }
  function unitLabel(title, quantity) {
    const one = quantity === 1;
    if (/variety pack/i.test(title)) return one ? 'Pack' : 'Packs';
    if (/cups/i.test(title)) return one ? 'Box' : 'Boxes';
    if (/steep bags/i.test(title)) return one ? 'Pack' : 'Packs';
    return one ? 'Bag' : 'Bags';
  }
  function updateSingleVariantQuantity(info, selected, variant, product, money) {
    const write = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
    info.querySelectorAll('.custom-quantity__selector.single-variant .oc__price-per-unit').forEach(box => {
      const priceNode = box.querySelector('.variant-price');
      write(priceNode, money(selected.total));
      let each = box.querySelector('.alac-custom-each');
      if (!each) { each = box.ownerDocument.createElement('span'); each.className = 'alac-custom-each'; box.append(each); }
      write(each, money(selected.price) + '/' + unitLabel(product.title, 1).toLowerCase());
    });
    info.querySelectorAll('.custom-quantity__selector.single-variant .sa-unitprice').forEach(node => {
      const base = Number(node.dataset.unitPrice);
      if (base && variant.price) write(node, money(base * selected.price / variant.price) + '/' + node.dataset.referenceUnit);
    });
  }
  function updatePurchaseOptionPrices(info, variant, subscriptionPrice, quantity, money, doc) {
    const count = Math.max(1, Number(quantity) || 1);
    const onceNode = info.querySelector('[data-alac-opt-price="once"]');
    const once = money(variant.price * count);
    if (onceNode && onceNode.textContent !== once) onceNode.textContent = once;
    const subNode = info.querySelector('[data-alac-opt-price="sub"]');
    if (!subNode) return;
    if (subscriptionPrice !== null && subscriptionPrice !== undefined && subscriptionPrice < variant.price) {
      const key = String(variant.id) + ':' + subscriptionPrice + ':' + count;
      if (subNode.dataset.alacFor !== key) {
        subNode.dataset.alacFor = key;
        const was = doc.createElement('s'); was.textContent = once;
        const now = doc.createElement('span'); now.textContent = money(subscriptionPrice * count);
        subNode.replaceChildren(was, ' ', now);
      }
    } else if (subNode.childNodes.length) { subNode.replaceChildren(); delete subNode.dataset.alacFor; }
  }
  function variantCanSubscribe(variant) { return variant.allocations.some(a => [4, 6, 8, 10, 12].includes(Number((String(a.name || '').match(/\b(\d+)\s*weeks?\b/i) || [])[1]))); }
  function cardQuote(product, variant, planId) {
    return quote(product, variant, planId, 1) || quote(product, variant, null, 1);
  }
  function canReleasePlanBlock(variant, quantityInput, submit) {
    return variant.available && quantityInput?.validity.valid !== false && submit.getAttribute('aria-disabled') !== 'true' && !submit.classList.contains('loading') && !/sold out|unavailable/i.test(submit.textContent);
  }
  function isMerchandiseUnit(node, form) { return node.parentElement.querySelector('[name="quantity"]')?.form === form; }
  function placeFormatPicker(choices, formats, frequency) {
    if (formats && formats.parentElement === frequency?.parentElement && choices.firstElementChild !== formats) choices.prepend(formats);
  }
  function positionPurchaseControls(info) {
    const choices = info?.querySelector('.custom-pdp-variant');
    const tabs = info?.querySelector('.oc__subscription-tabinner-box');
    const frequency = info?.querySelector('.recharge-picker__container');
    const formats = info?.querySelector('.custom-picker__container-all');
    if (!choices || !tabs || !frequency) return;
    placeFormatPicker(choices, formats, frequency);
    if (frequency.previousElementSibling !== tabs) { choices.append(tabs); choices.append(frequency); }
  }
  function packCount(title) {
    const t = String(title || '').trim();
    if (/^one\b/i.test(t)) return 1;
    const n = Number((t.match(/^(\d+)/) || [])[1]);
    return n > 0 ? n : 1;
  }
  // Recommended badge: the 3-pack. Shipping is stated separately on every eligible tile.
  function recommendBadge(count, price, isBag12, threshold, currency, money) {
    if (count !== 3) return null;
    const reaches = currency === 'USD' && threshold > 0 && price >= threshold;
    if (!isBag12 && !reaches) return null;
    return 'Recommended';
  }
  // Savings per tile against the 1-pack price in the same purchase mode. Sold-out tiles (available: false)
  // never set the baseline, never get a saving and never become "Best value".
  function tileSavings(tiles) {
    const live = t => t.available !== false;
    const single = tiles.find(t => t.count === 1 && live(t));
    if (!single) return tiles.map(() => null);
    const per = tiles.map(t => live(t) ? t.price / t.count : Infinity);
    const best = Math.min(...per);
    return tiles.map((t, i) => {
      if (t.count === 1 || !live(t)) return null;
      const save = single.price * t.count - t.price;
      if (save < 50) return null;
      return { save, pct: pctOff(single.price * t.count, t.price), best: per[i] === best };
    });
  }
  // Purchase bar: shown at every width, only while the real add-to-cart button is out of view.
  function watchSticky(sticky, button, Observer, previous, win) {
    previous?.disconnect();
    sticky.alacWatch = button;
    if (!button || (!Observer && !win)) return null;
    let last;
    let active = true;
    function apply(shown) {
      if (!active || shown === last) return;
      last = shown;
      sticky.classList.toggle('alac-sticky--show', shown);
      const body = sticky.ownerDocument?.body;
      body?.classList?.toggle('alac-sticky-shown', shown);
      if (shown && sticky.offsetHeight > 0) body?.style?.setProperty('--alac-sticky-h', sticky.offsetHeight + 'px');
    }
    function check() {
      const rect = typeof button.getBoundingClientRect === 'function' ? button.getBoundingClientRect() : null;
      if (rect) apply(rect.bottom < 0);
    }
    // Show only once the shopper has scrolled past the button (it sits above the viewport), never before reaching it.
    const watch = Observer ? new Observer(entries => {
      const entry = entries[entries.length - 1];
      const rect = entry.boundingClientRect;
      apply(!entry.isIntersecting && (!rect || rect.bottom <= 0));
    }) : null;
    watch?.observe(button);
    const timers = [];
    let frameId = null;
    const wait = (fn, ms) => (typeof win?.setTimeout === 'function' ? win.setTimeout(fn, ms) : setTimeout(fn, ms));
    const clearWait = id => (typeof win?.clearTimeout === 'function' ? win.clearTimeout(id) : clearTimeout(id));
    const queueFrame = fn => (typeof win?.requestAnimationFrame === 'function' ? win.requestAnimationFrame(fn) : wait(fn, 16));
    const cancelFrame = id => (typeof win?.cancelAnimationFrame === 'function' ? win.cancelAnimationFrame(id) : clearWait(id));
    const onScroll = () => {
      if (frameId !== null) return;
      frameId = queueFrame(() => { frameId = null; if (active) check(); });
    };
    const onSettle = () => check();
    const later = () => {
      const id = wait(() => { const at = timers.indexOf(id); if (at > -1) timers.splice(at, 1); if (active) check(); }, 600);
      timers.push(id);
    };
    const onClick = event => { if (event?.target?.closest?.('a[href^="#"]')) later(); };
    if (win?.addEventListener) {
      win.addEventListener('scroll', onScroll, { passive: true });
      win.addEventListener('scrollend', onSettle, { passive: true });
      win.addEventListener('hashchange', later);
      win.addEventListener('click', onClick);
    }
    const handle = watch || {};
    const stopObserver = typeof watch?.disconnect === 'function' ? watch.disconnect.bind(watch) : null;
    return Object.assign(handle, {
      check,
      disconnect() {
        active = false;
        stopObserver?.();
        if (frameId !== null) { cancelFrame(frameId); frameId = null; }
        if (win?.removeEventListener) {
          win.removeEventListener('scroll', onScroll, { passive: true });
          win.removeEventListener('scrollend', onSettle, { passive: true });
          win.removeEventListener('hashchange', later);
          win.removeEventListener('click', onClick);
        }
        timers.splice(0).forEach(clearWait);
      },
    });
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { watchSticky, pctOff, renewalText, setTerms, openSubHow, SUB_HOW_ID, supplyText, cadenceHelp, packNudge, orderSummary, shippingGuidance, shippingHeadline, shippingCondition, qualifiesShipping, cadenceGuidance, thresholdLabel, unitText, unitLabel, units, quote, variantCanSubscribe, cardQuote, canReleasePlanBlock, isMerchandiseUnit, placeFormatPicker, positionPurchaseControls, packCount, tileSavings, recommendBadge, updateSingleVariantQuantity, updatePurchaseOptionPrices }; return; }
  if (window.alacPdpValueLoaded) return;
  window.alacPdpValueLoaded = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  let timer;
  let stickyWatch = null;
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function schedule() { clearTimeout(timer); timer = setTimeout(update, 60); }
  // Watches only the product forms (variant id, button state and text), never the whole page:
  // the delivery countdown and late widgets elsewhere in the buy box do not trigger a full update.
  const observer = new MutationObserver(schedule);
  function observeForms() {
    document.querySelectorAll('[id^="MainProduct-"] product-form').forEach(node => observer.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] }));
  }
  window.alacPdpValueRefresh = schedule;
  window.alacPdpValuePrepareLayout = positionPurchaseControls;
  window.alacPdpValueUnmount = () => { clearTimeout(timer); observer.disconnect(); stickyWatch?.disconnect(); stickyWatch = null; };
  function update() {
    observer.disconnect();
    document.querySelectorAll('[id^="MainProduct-"]').forEach(root => {
      let info = root.querySelector('product-info');
      if (!info) return;
      let value = info.querySelector('[data-alac-value]') || root.querySelector('[data-alac-value]');
      if (!value) return;
      let product;
      try { product = JSON.parse(value.querySelector('[data-alac-product]').textContent); } catch (_) { return; }
      root.classList.add('alac-pdp');
      const previewBar = document.getElementById('PBarNextFrame')?.getBoundingClientRect();
      const previewOffset = previewBar ? (previewBar.height > 10 && previewBar.height < 120 ? previewBar.height : 64) : 0;
      root.style.setProperty('--alac-preview-offset', previewOffset + 'px');
      document.body.style.setProperty('--alac-preview-offset', previewOffset + 'px');
      const qualityBadge = document.getElementById('google-merchantwidget-iframe-wrapper');
      if (mobile.matches && qualityBadge) qualityBadge.style.setProperty('bottom', (100 + previewOffset) + 'px', 'important');
      // The H1 and the buy-box order are served in final form by sections/main-product.liquid;
      // this is only a safety net for markup from an older cached render.
      positionPurchaseControls(info);
      const form = info.querySelector('product-form form');
      if (!form) return;
      // Keep the selling plan and purchase-mode UI in step before quoting this variant.
      // The theme's click handler does not run for every way a radio can change.
      window.AlacSubscriptionPricing?.sync(info);
      const variantId = form.querySelector('[name="id"]')?.value;
      const variant = product.variants.find(v => String(v.id) === variantId);
      if (!variant) return;
      const subscribeInput = info.querySelector('[name="tabinner"][value="subscribeandsave"]');
      const subscribeOption = subscribeInput?.closest('.oc__subscription-tabinner-item');
      const canSubscribe = variantCanSubscribe(variant);
      if (subscribeOption && subscribeOption.hidden === canSubscribe) {
        subscribeOption.hidden = !canSubscribe;
        if (canSubscribe) subscribeOption.style.removeProperty('display');
        else subscribeOption.style.setProperty('display', 'none', 'important');
      }
      if (subscribeInput && subscribeInput.disabled === canSubscribe) subscribeInput.disabled = !canSubscribe;
      if (!canSubscribe) {
        const planInput = form.querySelector('[name="selling_plan"]');
        if (planInput?.value) planInput.value = '';
        if (subscribeInput?.checked) {
          info.querySelector('[name="tabinner"][value="buyonce"]')?.click();
          schedule();
          return;
        }
      }
      const subscribed = info.querySelector('[name="tabinner"]:checked')?.value === 'subscribeandsave';
      const planId = subscribed ? form.querySelector('[name="selling_plan"]')?.value : null;
      const quantityInput = [...root.querySelectorAll('[name="quantity"]')].find(input => input.form === form) || form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      info.querySelectorAll('.oc__quantity-unit').forEach(node => { if (isMerchandiseUnit(node, form)) setText(node, unitLabel(product.title, quantity)); });
      const selected = subscribed && !planId ? null : quote(product, variant, planId, quantity);
      root.classList.toggle('alac-plan-pending', !selected);
      const submit = info.querySelector('product-form [type="submit"]');
      if (selected && submit?.dataset.alacPlanBlocked === 'true' && canReleasePlanBlock(variant, quantityInput, submit)) {
        submit.disabled = false;
        delete submit.dataset.alacPlanBlocked;
      }
      const money = cents => new Intl.NumberFormat(product.locale, { style: 'currency', currency: product.currency }).format(cents / 100);
      const note = info.querySelector('[data-subscribe-note]') || root.querySelector('[data-subscribe-note]');
      const bestPlan = variant.allocations.filter(a => window.AlacSubscriptionPricing?.storefrontPlan(a)).reduce((min, a) => (min === null || a.price < min.price ? a : min), null);
      if (note) {
        const best = bestPlan?.price ?? null;
        const show = best !== null && best < variant.price;
        note.hidden = !show;
        if (show) {
          setText(note.querySelector('[data-subscribe-note-price]'), money(best * quantity));
          // Single baseline: this pack's one-time price.
          const saving = window.AlacSubscriptionPricing?.savings(variant.price, best);
          setText(note.querySelector('[data-subscribe-note-pct]'), saving ? ' · Save ' + saving.label + ' off the one-time price' : '');
        }
      }
      if (!selected) {
        setText(value.querySelector('[data-alac-total]'), '');
        setText(value.querySelector('[data-alac-total-label]'), 'Choose a delivery interval');
        setText(value.querySelector('[data-alac-unit]'), '');
        setText(info.querySelector('.alac-subscription-details'), 'Choose a delivery interval to confirm your subscription price.');
        const pendingOrder = info.querySelector('.alac-order-summary');
        setText(pendingOrder?.querySelector?.('[data-alac-ship-main]') || pendingOrder, 'Choose a delivery interval before adding a subscription.');
        setText(pendingOrder?.querySelector?.('[data-alac-ship-condition]'), '');
        info.querySelectorAll('.alac-tile-shipping').forEach(node => setText(node, ''));
        const sticky = root.querySelector('.alac-sticky');
        if (sticky) { setText(sticky.querySelector('span'), 'Choose an interval'); sticky.querySelector('button').disabled = true; const pendingTerms = sticky.querySelector('[data-alac-sticky-terms]'); if (pendingTerms) pendingTerms.hidden = true; }
        const pendingRenewal = info.querySelector('[data-alac-renewal]');
        if (pendingRenewal) pendingRenewal.hidden = true;
        if (submit && !submit.disabled) { submit.dataset.alacPlanBlocked = 'true'; submit.disabled = true; }
        observeForms();
        return;
      }
      setText(value.querySelector('[data-alac-total]'), money(selected.total));
      setText(value.querySelector('[data-alac-total-label]'), subscribed ? 'per delivery' : '');
      const u = selected.serving;
      setText(value.querySelector('[data-alac-unit]'), unitText(u, selected.price, money));
      setText(value.querySelector('[data-alac-note]'), u?.estimated ? 'Estimate uses 15g of coffee per 8 fl oz cup. Yield varies with brewing strength. Excludes shipping and tax.' : 'Excludes shipping and tax.');
      const supply = value.querySelector('[data-alac-supply]');
      if (supply) { const text = supplyText(u, quantity); setText(supply, text); supply.hidden = !text; }
      const selectedCadence = selected.allocation ? frequencyLabel(selected.allocation) : null;
      const cardPlanId = cardVariant => selectedCadence ? cardVariant.allocations.find(plan => frequencyLabel(plan) === selectedCadence)?.id : null;
      info.querySelectorAll('.option-container-size').forEach(card => {
        const radio = card.querySelector('[data-vid]');
        const v = product.variants.find(v => String(v.id) === radio?.dataset.vid);
        if (!v) return;
        const q = cardQuote(product, v, cardPlanId(v));
        setText(card.querySelector('.variant-price'), money(q.price));
        const soldOut = !v.available || radio.classList.contains('disabled');
        if (soldOut) radio.setAttribute('aria-disabled', 'true'); else radio.removeAttribute('aria-disabled');
        const discount = card.querySelector('.variant-discount');
        if (discount && !q.allocation) setText(discount, 'Save ' + discount.dataset.discount + '%');
        card.querySelectorAll('.sa-unitprice').forEach(node => {
          const base = Number(node.dataset.unitPrice);
          if (base) setText(node, money(base * q.price / v.price) + '/' + node.dataset.referenceUnit);
        });
        let serving = card.querySelector('.alac-card-unit');
        if (!serving) { serving = document.createElement('span'); serving.className = 'alac-card-unit'; card.querySelector('label').append(serving); }
        setText(serving, q.serving ? (q.serving.estimated ? '~' : '') + money(q.price / q.serving.count) + '/' + q.serving.noun : '');
      });
      // Custom stepper: show the line total for the chosen quantity, with the per-unit price underneath.
      info.querySelectorAll('variant-radios .custom-quantity__selector .oc__price-per-unit').forEach(box => {
        const priceNode = box.querySelector('.variant-price');
        if (!priceNode) return;
        setText(priceNode, money(selected.total));
        let each = box.querySelector('.alac-custom-each');
        if (!each) { each = document.createElement('span'); each.className = 'alac-custom-each'; box.append(each); }
        setText(each, money(selected.price) + '/' + unitLabel(product.title, 1).toLowerCase());
      });
      // A single-variant product has no pack tiles. Its visible quantity row
      // must follow the active selling-plan price just like the main total.
      updateSingleVariantQuantity(info, selected, variant, product, money);
      const packNoun = /cups/i.test(product.title) ? 'box' : /steep bags/i.test(product.title) ? 'bag' : /variety pack/i.test(product.title) ? 'pack' : 'bag';
      const tiles = [...info.querySelectorAll('.option-container-size')].filter(card => card.offsetParent !== null).map(card => {
        const v = product.variants.find(v => String(v.id) === card.querySelector('[data-vid]')?.dataset.vid);
        return v ? { card, v, count: packCount(v.title), price: cardQuote(product, v, cardPlanId(v)).price, available: !!v.available && !card.querySelector('[data-vid]').classList.contains('disabled') && (!subscribed || !!cardPlanId(v)) } : null;
      }).filter(Boolean);
      const isBag12 = /12oz/i.test(product.title) && !/cups|steep bags/i.test(product.title);
      tileSavings(tiles).forEach((saving, i) => {
        const card = tiles[i].card;
        const badge = tiles[i].available ? recommendBadge(tiles[i].count, tiles[i].price, isBag12, Number(product.threshold) || 0, product.currency, money) : null;
        card.classList.toggle('alac-tile--best', !!saving?.best && !badge);
        card.classList.toggle('alac-tile--rec', !!badge);
        let tag = card.querySelector('.alac-tile-tag');
        let save = card.querySelector('.alac-tile-save');
        let shipping = card.querySelector('.alac-tile-shipping');
        // Every tile keeps a savings line (empty on the 1-pack) so prices line up across the grid.
        if (!save) { save = document.createElement('span'); save.className = 'alac-tile-save'; card.querySelector('label').append(save); }
        setText(save, !subscribed && saving ? 'Save ' + money(saving.save) + ' (' + saving.pct + '%)' : '');
        if (!shipping) { shipping = document.createElement('span'); shipping.className = 'alac-tile-shipping'; card.querySelector('label').append(shipping); }
        setText(shipping, tiles[i].available && qualifiesShipping(tiles[i].price, Number(product.threshold), product.currency) ? 'Free Regular shipping*' : '');
        const tagText = badge || (saving?.best ? 'Best value per ' + packNoun : !subscribed && saving ? 'Save ' + saving.pct + '%' : '');
        // Every tile keeps its (server-rendered) tag element; an empty tag reserves its row in CSS.
        if (!tag) { tag = document.createElement('span'); tag.className = 'alac-tile-tag'; card.querySelector('label').prepend(tag); }
        setText(tag, tagText);
      });
      // The tile label is aria-hidden, so the radio's name carries the badge and the saving too.
      tiles.forEach(t => {
        const radio = t.card.querySelector('[data-vid]');
        const extra = [t.card.querySelector('.alac-tile-tag')?.textContent, t.card.querySelector('.alac-tile-save')?.textContent, t.card.querySelector('.alac-sub-save')?.textContent, t.card.querySelector('.alac-tile-shipping')?.textContent].map(x => (x || '').trim()).filter(Boolean);
        const name = radio.value + ', total ' + money(t.price) + (extra.length ? ', ' + extra.join(', ') : '') + (radio.getAttribute('aria-disabled') === 'true' ? ', sold out' : '');
        if (radio.getAttribute('aria-label') !== name) radio.setAttribute('aria-label', name);
      });
      const customRadio = info.querySelector('.option-container-custom input');
      const customTile = customRadio?.closest('.option-container-custom');
      if (customTile) {
        let shipping = customTile.querySelector('.alac-tile-shipping');
        if (!shipping) { shipping = document.createElement('span'); shipping.className = 'alac-tile-shipping'; customTile.querySelector('label')?.append(shipping); }
        const eligible = customRadio.checked && variant.available && qualifiesShipping(selected.total, Number(product.threshold), product.currency);
        setText(shipping, eligible ? 'Free Regular shipping*' : '');
        const customName = eligible ? 'Custom quantity, free Regular shipping subject to order total after discounts' : 'Custom quantity';
        if (customRadio.getAttribute('aria-label') !== customName) customRadio.setAttribute('aria-label', customName);
      }
      // Tile heights are equalised in CSS (grid rows plus a growing title row), not measured here.
      const nudge = info.querySelector('[data-alac-pack-nudge]');
      if (nudge) {
        const customOpen = !!info.querySelector('.option-container-custom input:checked');
        const text = customOpen ? packNudge(tiles, quantity, selected.price, unitLabel(product.title, quantity).toLowerCase(), money) : '';
        setText(nudge, text); nudge.hidden = !text;
      }
      const subSavingNode = info.querySelector('[data-alac-opt-saving="sub"]');
      const displayPlan = subscribed ? selected.allocation : bestPlan;
      const subBest = displayPlan?.price ?? null;
      updatePurchaseOptionPrices(info, variant, subBest, quantity, money, document);
      // One baseline everywhere: the strike price is this pack's one-time price and the saving is
      // measured against that same price, as a whole-number percentage rounded down.
      const displaySaving = displayPlan && subBest < variant.price ? window.AlacSubscriptionPricing?.savings(variant.price, subBest) : null;
      setText(subSavingNode, displaySaving ? quantity > 1
        ? 'Save ' + money((variant.price - subBest) * quantity) + ' on this order (' + displaySaving.label + ' off the one-time price)'
        : 'Save ' + money(variant.price - subBest) + ' (' + displaySaving.label + ') off the one-time price' : '');
      let benefits = info.querySelector('.alac-subscription-details');
      if (!benefits) { benefits = document.createElement('p'); benefits.className = 'alac-subscription-details'; info.querySelector('.recharge-picker__container')?.prepend(benefits); }
      const frequency = selected.allocation ? frequencyLabel(selected.allocation) : '';
      const benefitsText = selected.allocation ? 'Delivered every ' + frequency + '.' : '';
      setText(benefits, benefitsText); benefits.hidden = !benefitsText;
      const help = info.querySelector('[data-alac-cadence-help]');
      if (help) {
        const cadences = variant.allocations.filter(a => window.AlacSubscriptionPricing?.storefrontPlan(a)).map(a => window.AlacSubscriptionPricing.weeks(a.name));
        const text = subscribed ? cadenceHelp(u, quantity, cadences) : '';
        setText(help, text); help.hidden = !text;
      }
      let renewal = info.querySelector('[data-alac-renewal]') || info.querySelector('.alac-renewal');
      const formHost = info.querySelector('product-form');
      if (!renewal && formHost) { renewal = document.createElement('p'); renewal.className = 'alac-renewal'; renewal.setAttribute('role', 'status'); formHost.before(renewal); }
      const terms = subscribed ? renewalText(selected.allocation, selected.total, money) : '';
      if (renewal) setTerms(renewal, terms, document);
      let order = info.querySelector('.alac-order-summary');
      if (!order) { order = document.createElement('div'); order.className = 'alac-order-summary'; info.querySelector('product-form')?.before(order); }
      const headline = variant.available ? shippingHeadline(selected.total, Number(product.threshold) || 0, product.currency, money) : 'This selection is sold out.';
      const condition = variant.available ? shippingCondition(Number(product.threshold) || 0, product.currency, money) : '';
      const mainLine = order.querySelector?.('[data-alac-ship-main]');
      if (mainLine) {
        setText(mainLine, headline);
        setText(order.querySelector('[data-alac-ship-condition]'), condition);
      } else setText(order, headline + (condition ? ' ' + condition : ''));
      // Custom steppers: the close X is a span; make it a named, keyboard-operable button.
      info.querySelectorAll('.btn-close__selector').forEach(x => {
        if (x.getAttribute('role') === 'button') return;
        x.setAttribute('role', 'button'); x.tabIndex = 0;
        x.setAttribute('aria-label', x.closest('.recharge-picker__container') ? 'Close custom delivery frequency' : 'Close custom quantity');
        x.querySelector('svg')?.setAttribute('aria-hidden', 'true');
      });
      // Weeks stepper: name the field and its buttons for what they change.
      const weeks = info.querySelector('.recharge-picker__container [name="weeks"]');
      if (weeks && weeks.getAttribute('aria-label') !== 'Deliver every (weeks)') {
        weeks.setAttribute('aria-label', 'Deliver every (weeks)');
        const box = weeks.closest('quantity-input');
        setText(box?.querySelector('[name="minus"] .visually-hidden'), 'Fewer weeks between deliveries');
        setText(box?.querySelector('[name="plus"] .visually-hidden'), 'More weeks between deliveries');
      }
      // Benefit chips scroll sideways on phones: make the list focusable only while it overflows.
      const chips = root.querySelector('.alac-chips');
      if (chips) { const scrolls = chips.scrollWidth > chips.clientWidth + 1; if (scrolls && chips.tabIndex !== 0) chips.tabIndex = 0; else if (!scrolls && chips.hasAttribute('tabindex')) chips.removeAttribute('tabindex'); }
      // Sold out is announced through the polite price region.
      const totalLine = value.querySelector('.alac-value__total');
      if (totalLine) {
        let soldOut = totalLine.querySelector('[data-alac-soldout]');
        if (!soldOut) { soldOut = document.createElement('span'); soldOut.className = 'visually-hidden'; soldOut.dataset.alacSoldout = ''; totalLine.append(soldOut); }
        setText(soldOut, variant.available ? '' : ' Sold out');
      }
      // Format, grind and cadence choices are native radio inputs inside their labels (keyboard works without script).
      let sticky = root.querySelector('.alac-sticky');
      if (!sticky) {
        sticky = document.createElement('div'); sticky.className = 'alac-sticky';
        const details = document.createElement('div'); details.className = 'alac-sticky__info';
        const label = document.createElement('span'); label.dataset.alacStickyPrice = '';
        const stickyTerms = document.createElement('p'); stickyTerms.className = 'alac-sticky__terms'; stickyTerms.dataset.alacStickyTerms = ''; stickyTerms.hidden = true;
        details.append(label, stickyTerms);
        const button = document.createElement('button'); button.type = 'button'; button.addEventListener('click', () => {
          const mainButton = root.querySelector('product-form [type="submit"]');
          if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
          mainButton.click();
        }); sticky.append(details, button); root.append(sticky);
      }
      setText(sticky.querySelector('[data-alac-sticky-price]'), money(selected.total) + (subscribed ? ' per delivery' : ' total'));
      // Subscribe mode: the bar carries the same renewal terms as the main button, so it never enrolls without them.
      const stickyTerms = sticky.querySelector('[data-alac-sticky-terms]');
      if (stickyTerms && stickyTerms.dataset) setTerms(stickyTerms, terms, document);
      const mainButton = info.querySelector('product-form [type="submit"]');
      if (sticky.alacWatch !== mainButton) stickyWatch = watchSticky(sticky, mainButton, window.IntersectionObserver, stickyWatch, window);
      const disabled = !variant.available || !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || (subscribed && !selected.allocation);
      sticky.querySelector('button').disabled = disabled;
      const cta = !variant.available || /sold out|unavailable/i.test(mainButton?.textContent || '') ? 'Sold out' : subscribed ? 'Start subscription' : 'Add to cart';
      setText(sticky.querySelector('button'), cta);
      if (sticky.classList.contains('alac-sticky--show')) document.body.style.setProperty('--alac-sticky-h', sticky.offsetHeight + 'px');
      if (mainButton && variant.available && !mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true' && !mainButton.classList.contains('loading')) setText(mainButton.querySelector(':scope > span:first-child'), cta);
    });
    observeForms();
  }
  document.addEventListener('submit', event => {
    const pending = event.target.closest('.alac-plan-pending');
    if (!pending) return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.AlacSubscriptionPricing?.planError?.(pending.querySelector('product-info') || pending, true);
    schedule();
  }, true);
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  // "How it works" next to the renewal terms opens the subscription accordion before the fragment jump.
  document.addEventListener('click', event => { openSubHow(document, event.target); });
  // These are labels, not form controls. Keep selection working even if the
  // section's page-load click initializer did not bind or the section is replaced.
  document.addEventListener('click', event => {
    const label = event.target.closest?.('.alac-pdp .recharge-picker__container .recharge-option label');
    if (label) {
      window.AlacSubscriptionPricing?.selectCadence(label.closest('.recharge-picker__container'), label);
      schedule();
      return;
    }
    const close = event.target.closest?.('.alac-pdp .btn-close__selector');
    if (!close || event.alacCloseHandled) return;
    window.AlacSubscriptionPricing?.closeEditor(close.closest('[id^="MainProduct-"]'), close);
    schedule();
  });
  // One debounced update per click; later button or variant-id changes arrive through the form observer.
  document.addEventListener('click', event => { if (event.target.closest?.('[id^="MainProduct-"]')) schedule(); });
  document.addEventListener('keydown', event => { if (event.target.matches?.('.alac-pdp .btn-close__selector[role="button"]') && ['Enter', ' '].includes(event.key)) { event.preventDefault(); event.target.click(); } });
  // Keyboard focus follows the Custom steppers: into the stepper when it opens, back to the choices
  // when it closes (the hidden tile or button would otherwise drop focus to the page).
  document.addEventListener('click', event => {
    if (event.detail !== 0) return; // pointer clicks keep the browser's own focus
    const target = event.target;
    const opener = target.closest?.('.alac-pdp .option-container-custom, .alac-pdp .recharge-option > label[data-value="custom"]');
    const closer = target.closest?.('.alac-pdp .btn-close__selector');
    if (!opener && !closer) return;
    const scope = (opener || closer).closest('variant-radios, .recharge-options');
    setTimeout(() => {
      if (!scope) return;
      if (opener) {
        const input = [...scope.querySelectorAll('.custom-quantity__selector input')].find(i => i.offsetParent !== null);
        input?.focus();
      } else {
        const back = scope.querySelector('.option-container input:checked') || scope.querySelector('.recharge-option > label.selected, .recharge-option > label');
        back?.focus();
      }
    }, 80);
  });
  // Phones: keep the focused control above the sticky add-to-cart bar (2.4.11).
  document.addEventListener('focusin', event => {
    const bar = document.querySelector('.alac-sticky');
    if (!bar || !mobile.matches || bar.contains(event.target) || getComputedStyle(bar).display === 'none') return;
    // Only page content: skip fixed overlays (cookie banner, chat, drawers) that sit above the bar anyway.
    if (!event.target.closest?.('.alac-pdp') || event.target.closest('cart-drawer, [role="dialog"]') || !event.target.matches(':focus-visible')) return;
    for (let n = event.target; n && n !== document.body; n = n.parentElement) if (getComputedStyle(n).position === 'fixed') return;
    const top = bar.getBoundingClientRect().top;
    const rect = (event.target.matches('input[type="radio"]') && event.target.nextElementSibling ? event.target.nextElementSibling : event.target).getBoundingClientRect();
    if (rect.top < top && rect.bottom > top - 4) window.scrollBy(0, rect.bottom - top + 16);
  });
  mobile.addEventListener('change', schedule);
  window.addEventListener('load', schedule);
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
})();
